export const ON_BEHALF_OF_QUERY_PARAM = 'onBehalfOf';
export const RESET_ON_BEHALF_OF_QUERY_PARAM = 'resetOnBehalfOf';
